import { getAppConfig } from '@services/config';
import { CACHE_TAGS } from '@services/http/http';

import { AnimcoBannerType, AnimcoType, BlueBannerAnimcoApi, BlueBannerItemApi } from '@app-types/animco';
import { PalpatineProduct } from '@app-types/api/palpatine';

import { filterValidItems, isValidDateRange } from '@helpers/content-editor';

import { JourneyType } from '@constants/journey';

import { httpService } from './http';

const appConfig = getAppConfig();

export const getProductAnimco = (items: PalpatineProduct[], slug: string, isRenewal: boolean): AnimcoType => {
    const journeyType = isRenewal ? JourneyType.RENEWAL : JourneyType.ACQUISITION;
    const productAnimcoList = items.filter((datum) => datum.Slug === slug || datum.Slug === 'all-phones');

    const boxAnimcoList: AnimcoType['box'] = productAnimcoList
        .flatMap((datum) => datum.anim_animco_list.items)
        .filter((datum) => filterValidItems(journeyType, datum.parcours, datum.start_date, datum.end_date))
        .sort((a, b) => a.order - b.order)
        .map((animco) => ({
            type: animco.type,
            promoCode: animco?.promo_code,
            text: animco.text,
            tooltip: animco?.tooltip,
        }));

    const bannerAnimcoList: AnimcoBannerType[] = productAnimcoList
        .flatMap((datum) => datum.banner_animco_list.items)
        .filter((datum) => filterValidItems(journeyType, datum.parcours, datum.start_date, datum.end_date))
        .map((banner) => ({
            hasDisplaySticker: banner.display_sticker,
            stickerValue: banner.sticker_value,
            text: banner.text,
        }));

    return { box: boxAnimcoList, banner: bannerAnimcoList };
};

export const mapItemToBanner = (item: BlueBannerItemApi): AnimcoBannerType | undefined => {
    if (isValidDateRange(item.start_date, item.end_date)) {
        return {
            stickerValue: item.sticker_value ?? '',
            text: item.text ?? item.title ?? '',
            stickerColor: item.sticker_color,
            stickerTooltip: item.sticker_tooltip,
            hasDisplaySticker: !!item.sticker_value,
            startDate: item.start_date,
            endDate: item.end_date,
        };
    }
};

export const getBlueBannerContent = async (animCoUrl: string): Promise<AnimcoBannerType[]> => {
    return httpService
        .get<BlueBannerAnimcoApi>(
            `${appConfig.assets.palpatine.plans}/forfaits_emplacement/${animCoUrl}`,
            {
                findByKey: 'slug',
            },
            {
                ttl: parseInt(appConfig.cache.ttl.cms),
                tags: [CACHE_TAGS.CMS],
            },
        )
        .then((animcoApi) => animcoApi.bandeau_bleu_list.items.map(mapItemToBanner).filter((x) => !!x))
        .catch(() => []);
};
